/**
 * Reusable empty cell component for table
 */

import { FC, ReactNode } from "react";

interface EmptyCellProps {
  value: ReactNode;
}

export const EmptyCell: FC<EmptyCellProps> = ({ value }) => {
  return value ? <span>{value}</span> : <div>‒</div>;
};
